angular.module('angus.directives').directive('dashboard', [
    function() {
        return {
            templateUrl: 'templates/authenticated/dashboard/dashboard.html'
        };
    }
]);